import React from "react";
import { useNavigate } from "react-router-dom";
import { IconClose1 } from "@velaro/velaro-component-lib";

/**
 * Shared back button for integration pages.
 * Use as `headerActions` in RouteHeader to ensure every integration page
 * gets a consistent back button automatically.
 *
 * @param backTo - The path to navigate back to. Defaults to "/integrations".
 */
export function BackToIntegrations({ backTo = "/integrations" }: { backTo?: string }) {
  const navigate = useNavigate();
  return (
    <button
      className="flex cursor-pointer items-center gap-1.5 text-slate-600 hover:text-slate-800 transition-colors"
      onClick={() => navigate(backTo)}
      aria-label="Back to integrations"
    >
      <IconClose1 className="h-6 w-6" />
    </button>
  );
}

export default BackToIntegrations;
